// extracted by mini-css-extract-plugin
export var attachment = "_o0-a";
export var emailContainer = "_o0-4";
export var emailContentPaddedContainer = "_o0-b";
export var emailHeader = "_o0-6";
export var emailIframe = "_o0-3";
export var emailInfoIcon = "_o0-9";
export var emailShortenedSummary = "_o0-e";
export var infoDropdown = "_o0-0";
export var infoRowBoundedContent = "_o0-d";
export var internal = "_o0-5";
export var merchant = "_o0-8";
export var messageInputContainer = "_o0-h";
export var normal = "_o0-7";
export var replyCard = "_o0-f";
export var subtleButton = "_o0-1";
export var subtleButtonIconContainer = "_o0-2";
export var toggleViewRepliesButton = "_o0-c";
export var wrappingText = "_o0-g";